import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, Validator} from '@angular/forms';

const SELECT_MONTH_PICKER_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MonthPickerComponent)
};

@Component({
    selector: 'app-month-picker',
    template: `
        <select class="form-control" id="{{ elemId }}" name="{{ elemId }}" [(ngModel)]="selectedValue">
            <option value="" >Choose a month</option>
            <option *ngFor="let month of months" value="{{ month.value }}">{{ month.label }}</option>
        </select>
        `,
    styleUrls: ['./month-picker.component.scss'],
    providers: [SELECT_MONTH_PICKER_VALUE_ACCESSOR]
})
export class MonthPickerComponent implements OnInit, ControlValueAccessor {

    @Input() elemId: string;

    months: Array<Object>;
    _selectedValue: any;
    private onTouched: Function;

    constructor() {
        this.months = [
            { label: 'January', value: '01'},
            { label: 'February', value: '02'},
            { label: 'March', value: '03'},
            { label: 'April', value: '04'},
            { label: 'May', value: '05'},
            { label: 'June', value: '06'},
            { label: 'July', value: '07'},
            { label: 'August', value: '08'},
            { label: 'September', value: '09'},
            { label: 'October', value: '10'},
            { label: 'November', value: '11'},
            { label: 'December', value: '12'}
        ]
    }

    ngOnInit() {
    }

    get selectedValue(): any { return this._selectedValue; };

    set selectedValue(v: any) {
        //if (v !== this._selectedValue) {
        this._selectedValue = v;
        this.propagateChange(this._selectedValue);
        //}
    }

    propagateChange = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(value: any): void {
        this._selectedValue = value;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/month-picker/month-picker.component.ts